import React from "react"
import get from "lodash/get"

import {axios} from "@lib/helpers"

type PropTypes = {
  data: {
    t: RailsI18n.T
    personal_identity_image_path: string
    personal_identity_image: string
  }
}

const PersonalIdentityImage: ReactFC<PropTypes> = ({data}) => {
  const {t, personal_identity_image_path, personal_identity_image} = data
  const __formRef = React.useRef()
  const __inputRef = React.useRef()

  const __fileSelect = (event) => {
    event.preventDefault()
    __inputRef.current.click()
  }

  const __fileDelete = (event) => {
    event.preventDefault()
    const result = window.confirm(get(t, "current.can_delete"))
    if (result) {
      axios.delete(personal_identity_image_path, null).then((res) => {
        window.location.reload()
      })
    }
  }

  return (
    <div className="AppPersonalIdentityImage">
      <h1 className="App__h1">{get(t, "current.title")}</h1>
      <p className="App__p__small">{get(t, "current.p")}</p>
      <p className="App__p__bold">{get(t, "current.p2")}</p>
      <p className="App__p__red App__p__small">{get(t, "current.p3")}</p>
      <br />
      {personal_identity_image && (
        <React.Fragment>
          <img src={personal_identity_image} />
          <br />
          <button className="Button" onClick={__fileSelect}>
            {get(t, "current.edit")}
          </button>
          <br />
          <button
            className="Button Button--red-bordered"
            onClick={__fileDelete}
          >
            {get(t, "current.delete")}
          </button>
        </React.Fragment>
      )}
      {!personal_identity_image && (
        <button className="Button" onClick={__fileSelect}>
          {get(t, "current.button")}
        </button>
      )}
      <form
        ref={__formRef}
        action={personal_identity_image_path}
        method="post"
        encType="multipart/form-data"
      >
        <input
          type="hidden"
          name="authenticity_token"
          value={document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content")}
        />
        <input type="hidden" name="_method" value="patch" autoComplete="off" />
        <input
          hidden
          type="file"
          name="user[personal_identity_image]"
          ref={__inputRef}
          onChange={(e) => {
            e.preventDefault
            __formRef.current.submit()
          }}
        />
      </form>
    </div>
  )
}

export default PersonalIdentityImage
